<script setup lang="ts">
import { ref, computed, onMounted, onBeforeUnmount, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useAuthStore } from '../stores/auth'

const { t } = useI18n()
const authStore = useAuthStore()

const shouldShow = computed(() => authStore.isDemo && authStore.demoStatus === 'active')

const visible = ref(false)
let hideTimer: ReturnType<typeof setTimeout> | null = null

function scheduleHide() {
  if (hideTimer) clearTimeout(hideTimer)
  if (!shouldShow.value) {
    visible.value = false
    return
  }
  visible.value = true
  hideTimer = setTimeout(() => {
    visible.value = false
  }, 10000)
}

onMounted(scheduleHide)
watch(shouldShow, scheduleHide)

onBeforeUnmount(() => {
  if (hideTimer) clearTimeout(hideTimer)
})
</script>

<template>
  <div
    v-if="shouldShow && visible"
    class="mx-4 mt-4 bg-amber-50 border-2 border-amber-300 rounded p-4"
  >
    <p class="text-sm font-semibold text-amber-800">{{ t('demo.restrictions.onlinePaymentsTitle') }}</p>
    <p class="text-sm text-amber-700 mt-1">{{ t('demo.restrictions.onlinePaymentsText') }}</p>
  </div>
</template>
